<template>
  <div class="">
    <dg-head>
      <div class="flex items-center">
        <p class="cursor-pointer pr-[40]" @click="push({ path: '/register' })"><i class="icon">&#xe6c4;</i> 注册</p>
        <a :href="ENV.official" target="_blank"> <el-button size="mini" type="primary">返回首页</el-button></a>
      </div>
    </dg-head>
    <div class="min-h-[84vh] pt-[100] md:pt-[50] md:min-h-[80vh]">
      <div class="w-[1200] mx-[auto] rounded-[4] bg-[#fff] h-[516] flex shadow">
        <div class="w-[740]">
          <img src="../assets/img/login-img.jpg" class="w-[100%] h-[516]" alt="" />
        </div>
        <div class="flex-1 px-[78]">
          <div class="flex justify-between pt-[70] items-center">
            <p class="t-[24] t-[#192530] font-500">登录</p>
            <div class="flex overflow-hidden cursor-pointer leading-[32] text-center">
              <p class="w-[60] rounded-[2] border-[#dcdfe6] border-y-[1px] border-l-[1px] border-solid" :class="{ 't-[#fff] bg-[theme] border-[theme]': loginType == 0 }" @click="loginType = 0">账号</p>
              <p :class="{ 't-[#fff] bg-[theme] border-[theme]': loginType == 1 }" @click="loginType = 1" class="w-[60] rounded-[2] border-[#dcdfe6] border-y-[1px] border-r-[1px] border-solid">手机号</p>
            </div>
          </div>
          <dg-alert-box class="pt-[30]">
            <el-form :model="loginForm" ref="loginFormRef" label-width="1px">
              <el-form-item v-show="loginType == 0" label="" prop="loginName" :rules="[{ required: loginType == 0, message: '请输入账户' }]" class="relative mb-[20]">
                <el-input size="large" class="large_input" placeholder="请输入账户" v-model="loginForm.loginName"> </el-input>
              </el-form-item>
              <el-form-item label="" v-show="loginType == 1" prop="mobile" :rules="[{ required: loginType == 1, message: '请输入手机号' }]" class="relative mb-[20]">
                <el-input size="large" class="large_input" placeholder="请输入手机号" maxlength="11" v-model="loginForm.mobile"> </el-input>
              </el-form-item>
              <el-form-item v-show="loginType == 0" label="" prop="password" :rules="[{ required: loginType == 0, message: '请输入登录密码' }]" class="relative mb-[20]">
                <el-input size="large" class="large_input" placeholder="请输入登录密码" show-password v-model="loginForm.password"> </el-input>
              </el-form-item>
              <el-form-item label="" class="mb-[20]" prop="catchcode" :rules="[{ required: loginType == 1, message: '请输入验证码' }]">
                <div class="flex">
                  <div class="relative flex-1">
                    <el-input size="large" class="large_input" placeholder="请输入验证码" @keyup.enter.native="handleLogin('loginFormRef')" v-model="loginForm.catchcode"> </el-input>
                  </div>
                  <div class="verificationCode w-[110] pl-[10]" @click="getcaptcha">
                    <img :src="verificationCode" class="w-[100%] h-[100%]" alt="" />
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="" class="mb-[20]" prop="messagecode" v-show="loginType == 1" :rules="[{ required: loginType == 1, message: '请输入短信验证码' }]">
                <div class="flex">
                  <div class="relative flex-1 messagecode">
                    <el-input size="large" @keyup.enter.native="handleLogin('loginFormRef')" class="large_input" placeholder="请输入短信验证码" v-model="loginForm.messagecode">
                      <template v-slot:suffix>
                        <div class="suffix cursor-pointer border-l-[1] border-[#d5dae5] border-solid w-[100] leading-[24] my-[9] t-[theme]" @click="handleSend">{{ CountDownStatus ? "发送短信" : `${CountDownNum}/s` }}</div>
                      </template>
                    </el-input>
                  </div>
                </div>
              </el-form-item>

              <div class="pt-[10]">
                <el-button class="w-[100%]" type="primary" @click="handleLogin('loginFormRef')" :loading="showLoading">登录</el-button>
              </div>
              <div class="flex justify-between pt-[20]">
                <p class="cursor-pointer t-[theme]" @click="push({ path: '/forgetPasw' })">忘记密码？</p>
                <p class="t-[theme] cursor-pointer" @click="push({ name: 'register' })">快速注册</p>
              </div>
            </el-form>
          </dg-alert-box>
        </div>
      </div>
    </div>

    <dg-copyright></dg-copyright>
  </div>
</template>
<script>
import CountDown from "@/assets/js/countDown";
import { deepCopyRef, encryptDES, isIE } from "../assets/js/utils";
import SmsSenderCheck from "@/assets/js/SmsSenderCheck";
let smsSenderCheck = new SmsSenderCheck("login");
import mixin from "@/assets/js/mixin";
export default {
  mixins: [mixin],
  data() {
    return {
      loginType: 0,
      isIE: isIE(),      
      showLoading: false,
      CountDownNum: 60,
      CountDownStatus: true,
      countDown: {},
      verificationCode: "",
      loginForm: {
        loginName: "", // 账户名 17750877007
        password: "", // 123456  密码，cookie值加上当前日期做密钥（JSESSIONID-yyyy-MM-dd），对明文进行des加密
        catchcode: "", // 图形验证码
        mobile: "", // 图形验证码
        messagecode: "", // 短信验证码
      },
      tips: {
        msg: "",
        type: "error",
      },
    };
  },
  watch: {
    loginType() {
      this.$refs["loginFormRef"].clearValidate();
    },
  },
  methods: {
    /**
     * @author 伟健 / 张
     * @name 登录
     */
    handleLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.loginType == 1) {
            // 手机号登录
            this.showLoading = true;
            ajax.post({
              url: "/supplyChain/auth/mobileLogin",
              data: {
                messagecode: this.loginForm.messagecode, // 短信验证码
                mobile: this.loginForm.mobile, // 手机号
              },
              self: this,
              success: (res) => {
                console.log(res);
                if (res) {
                  this.getCurrent();
                }
                this.showLoading = false;
              },
              fail: () => {
                this.showLoading = false;
              },
            });
          }
          if (this.loginType == 0) {
            // 密码登录
            let _loginForm = deepCopyRef(this.loginForm);
            _loginForm.password = encryptDES(_loginForm.password);
            this.showLoading = true;
            ajax.post({
              url: "/supplyChain/auth/login",
              data: _loginForm,
              self: this,
              success: (res) => {
                if (res) {
                  this.getCurrent();
                }
                this.showLoading = false;
              },
              fail: () => {
                this.getcaptcha();
                this.showLoading = false;
              },
            });
          }
        }
      });
    },
    /**
     * @author 伟健 / 张
     * @name 用户信息
     */
    getCurrent() {
      this.showLoading = true;
      ajax.post({
        url: "/supplyChain/user/current",
        data: {},
        self: this,
        success: (res) => {
          console.log(res);
          if (res && res.user) {
            localStorage.setItem("current", JSON.stringify(res));
            this.push({ path: "/" });
          }
          this.showLoading = false;
        },
        fail: () => {
          this.showLoading = false;
        },
      });
    },
    /**
     * @author 伟健 / 张
     * @name 发送短信
     */
    handleSend() {
      smsSenderCheck.check((valid, fn) => {
        if (valid) {
          let hasError = false;
          this.$refs["loginFormRef"].validateField(["mobile", "catchcode"], (err) => {
            if (err) {
              hasError = true;
              return;
            }
          });
          if (!hasError) {
            ajax.post({
              url: "/supplyChain/common/sendSmsCode",
              data: {
                catchcode: this.loginForm.catchcode, // 图形验证码
                mobile: this.loginForm.mobile, // 手机号码
              },
              self: this,
              success: (res) => {
                if (res) {
                  this.countDown.start();
                  fn();
                }
              },
              fail: () => {
                this.loginForm.catchcode = "";
                this.getcaptcha();
              },
            });
          }
        } else {
          return;
        }
      });
    },
    /**
     * @author 伟健 / 张
     * @name
     */
    getcaptcha() {
      ajax.post({
        url: "/supplyChain/common/getcaptcha",
        data: {},
        self: this,
        success: (res) => {
          if (res) {
            this.verificationCode = res;
          }
        },
        fail: () => {},
      });
    },
  },
  mounted() {
    if (localStorage.getItem("relogin")) {
      this.tips.msg = "登录已超时，请重新登录";
      setTimeout(() => {
        localStorage.removeItem("relogin");
      }, 1000);
    }
  },
  created() {
    this.getcaptcha();
    this.countDown = new CountDown({
      self: this,
      /*   这两参数必填
       "CountDownNum": 30,
       "CountDownStatus": true,
       */
      id: "login",
    });
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/css/var.less";
.shadow {
  box-shadow: 0 2px 10px 0 rgba(45, 72, 97, 0.1);
}
</style>
 <style>.pr-\[40\] {
    padding-right: 40px
}
.min-h-\[84vh\] {
    min-height: 84vh
}
.pt-\[100\] {
    padding-top: 100px
}
.w-\[1200\] {
    width: 1200px
}
.mx-\[auto\] {
    margin-left: auto;
    margin-right: auto
}
.rounded-\[4\] {
    border-radius: 4px
}
.bg-\[\#fff\] {
    background-color: #fff
}
.h-\[516\] {
    height: 516px
}
.w-\[740\] {
    width: 740px
}
.w-\[100\%\] {
    width: 100%
}
.px-\[78\] {
    padding-left: 78px;
    padding-right: 78px
}
.pt-\[70\] {
    padding-top: 70px
}
.t-\[24\] {
    font-size: 24px
}
.t-\[\#192530\] {
    color: #192530
}
.leading-\[32\] {
    line-height: 32px
}
.w-\[60\] {
    width: 60px
}
.rounded-\[2\] {
    border-radius: 2px
}
.border-\[\#dcdfe6\] {
    border-color: #dcdfe6
}
.border-y-\[1px\] {
    border-top-width: 1px;
    border-bottom-width: 1px
}
.border-l-\[1px\] {
    border-left-width: 1px
}
.t-\[\#fff\] {
    color: #fff
}
.bg-\[theme\] {
    background-color: #008AA6
}
.border-\[theme\] {
    border-color: #008AA6
}
.border-r-\[1px\] {
    border-right-width: 1px
}
.pt-\[30\] {
    padding-top: 30px
}
.mb-\[20\] {
    margin-bottom: 20px
}
.w-\[110\] {
    width: 110px
}
.pl-\[10\] {
    padding-left: 10px
}
.h-\[100\%\] {
    height: 100%
}
.border-l-\[1\] {
    border-left-width: 1px
}
.border-\[\#d5dae5\] {
    border-color: #d5dae5
}
.w-\[100\] {
    width: 100px
}
.leading-\[24\] {
    line-height: 24px
}
.my-\[9\] {
    margin-top: 9px;
    margin-bottom: 9px
}
.t-\[theme\] {
    color: #008AA6
}
.pt-\[10\] {
    padding-top: 10px
}
.pt-\[20\] {
    padding-top: 20px
}
.flex {
    display: flex
}
.items-center {
    align-items: center
}
.cursor-pointer {
    cursor: pointer
}
.flex-1 {
    flex: 1 1 0%
}
.justify-between {
    justify-content: space-between
}
.font-500 {
    font-weight: 500
}
.overflow-hidden {
    overflow: hidden
}
.text-center {
    text-align: center
}
.border-solid {
    border-style: solid
}
.relative {
    position: relative
}</style>